import React, { useContext, useEffect, useRef, useState } from "react";
import { DirectionalHint } from "@fluentui/react/lib/ContextualMenu";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import ImageIndicator from "../../../../components/SVGComponents/ImageIndicator";
import themeContext from "../../../../context/theme/ThemeContext";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost";
import ReportTemplateIndicatorIcon from "../../../../components/SVGComponents/ReportTemplateIndicatorIcon";
import DropDown from "../../../../components/SVGComponents/Tools/DropDown";
import { stylesForCustomSelect } from "../../../../components/CustomSelect";

const ReportTemplateIndicator = (props) => {
  const {
    reportTitle,
    setReportTitle,
    llmReportTitle,
    agenticReportAgents
  } = useContext(studyReportContext);
  
  const [dropDownHovered, setDropDownHovered] = useState(false);
  const { getThemeColor, theme, themeName } = useContext(themeContext);
  const [menuVisible, setMenuVisible] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (llmReportTitle) {
      setReportTitle(llmReportTitle);
    } else {
      setReportTitle("");
    }
  }, [llmReportTitle]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setMenuVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleTemplateSelect = (templateTitle) => {
    const selected = agenticReportAgents.find((t) => t.title === templateTitle);
    setReportTitle(templateTitle);
    setMenuVisible(false);
    if (props.onTemplateSelect && selected) {
      props.onTemplateSelect(selected);
    }
  };

  const styles = mergeStyleSets({
    dropdownContainer: {
      position: "absolute",
      top: "100%",
      left: 0,
      backgroundColor: getThemeColor("action-details-background"),
      borderRadius: 5,
      border: "1px solid #585858",
      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
      marginTop: 4,
      zIndex: 100,
      overflow: "hidden",
      minWidth: 200,
    },
    dropdownItem: {
      padding: "8px 12px",
      cursor: "pointer",
      color: themeName !== "light"?"#FFF":"#000"
    },
  });

  return (
    <div className="report-template-indicator" style={{ position: "relative" }} ref={containerRef}>
      <CustomToolTipHost
        content={
          reportTitle.trim()
            ? `${reportTitle} is selected`
            : "No template selected"
        }
        id="Image Indicator"
        directionalHint={DirectionalHint.topCenter}
        tooltipProps={{
          calloutProps: {
            styles: {
              beak: { background: "#252525" },
              beakCurtain: { background: "#252525" },
              calloutMain: { background: "#252525" },
              borderRadius: "20%",
            },
          },
        }}
      >
        <div className="highlight-tool"
          style={{
              width: "42px"
            }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              cursor: "pointer",
            }}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              setMenuVisible((prev) => !prev);
            }}
            onMouseOver={() => setDropDownHovered(true)}
            onMouseLeave={() => setDropDownHovered(false)}
          >
            <ReportTemplateIndicatorIcon isImage={reportTitle !== ""} />
            <DropDown
              color={
                dropDownHovered
                  ? theme.palette.activeTool
                  : theme.palette.inactiveTool
              }
            />
          </div>
        </div>

      </CustomToolTipHost>
      
      {menuVisible && (
        <div className={styles.dropdownContainer}>
          {[...agenticReportAgents]
            .sort((a, b) => (a.title === reportTitle ? -1 : b.title === reportTitle ? 1 : 0))
            .map((template, index) => {
              const isActive = template.title === reportTitle;
              return (
                <div
                  key={template.id || index}
                  className={styles.dropdownItem}
                  onClick={() => handleTemplateSelect(template.title)}
                  style={{
                    backgroundColor: isActive
                      ? getThemeColor("highlight") || "rgba(255,255,255,0.2)"
                      : "transparent",
                    fontWeight: isActive ? "bold" : "normal",
                  }}
                  // styles={stylesForCustomSelect(getThemeColor)}
                  onMouseEnter={(e) =>
                    !isActive &&
                    (e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.1)")
                  }
                  onMouseLeave={(e) =>
                    !isActive &&
                    (e.currentTarget.style.backgroundColor = "transparent")
                  }
                >
                  {template.title}
                </div>
              );
            })}
        </div>
      )}
    </div>
  );
};

export default ReportTemplateIndicator;
